import { render, staticRenderFns } from "./MenuCheers.vue?vue&type=template&id=4fec5f8f&"
import script from "./MenuCheers.vue?vue&type=script&lang=js&"
export * from "./MenuCheers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports